import React from "react";
import { SourceEditor } from "../editors";

/**
 * Profile → Source tab. The iconik-hosted source asset (no operator upload in the first slice) —
 * parse status, dimensions, and (for XLSX) the operator-guided worksheet/header/data-row selection
 * — plus the detected columns.
 */

export default function SourcePanel({ id }: { id: string }) {
  return <SourceEditor id={id} />;
}
